import React, { useState } from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ActionBarItem } from "../../../../../../shared/components/table/FloatingActionBar"
import { faCircleEllipsis, faPrint } from "@fortawesome/pro-light-svg-icons"
import { Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    printIcon: {
        marginRight: "0.5rem",
        color: "#2196f3",
    },
}))

export function ActionBarItemPrintGuestLabels({ onClick }: { onClick: () => void }) {
    const { classes } = useStyles()
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
    const [menuOpen, setMenuOpen] = useState<boolean>(false)

    function handleMenuClick(event: React.MouseEvent<HTMLElement>): void {
        setAnchorEl(event.currentTarget)
        setMenuOpen(true)
    }

    function handleMenuClose(): void {
        setMenuOpen(false)
    }

    return (
        <>
            <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action">
                <ActionBarItem icon={faCircleEllipsis} title="Other" onClick={handleMenuClick} />
            </LocalizedStrict>
            <Menu
                disableScrollLock
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <MenuItem onClick={onClick}>
                    <FontAwesomeIcon className={classes.printIcon} icon={faPrint} />
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action">
                        <> Print guest labels </>
                    </LocalizedStrict>
                </MenuItem>
            </Menu>
        </>
    )
}

